var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M20.368 10.228c.001-.681-.057-1.362-.173-2.033h-9.496v3.851h5.439a4.61 4.61 0 0 1-2.011 3.039v2.5h3.246c1.9-1.74 2.995-4.314 2.995-7.357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M10.7 20c2.717 0 5.005-.886 6.673-2.414l-3.246-2.5c-.903.609-2.067.956-3.427.956-2.627 0-4.856-1.758-5.653-4.128H1.703v2.577a10.03 10.03 0 0 0 3.712 4.02A10.1 10.1 0 0 0 10.7 20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M5.047 11.914a5.95 5.95 0 0 1 0-3.828V5.51H1.703a9.94 9.94 0 0 0 0 8.98z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M10.7 3.959a5.5 5.5 0 0 1 3.862 1.5l2.874-2.854A9.7 9.7 0 0 0 10.7 0C8.833 0 7.004.516 5.415 1.489A10.03 10.03 0 0 0 1.703 5.51l3.344 2.576C5.844 5.717 8.073 3.96 10.7 3.96"
  })));
};
export default SvgGoogleIcon;